import { useTranslation } from "react-i18next";
import { CustomIcon } from "components/icon/customIcon.component";
import { Text } from "components/designV2/text/text";
import { ColorV2 } from "config/colors";
import {
  DeviationHeader,
  DeviationList,
  DeviationRow,
  DeviationSection,
  DeviationValue,
} from "./clockStampCheckInOutModal.styled";
import {
  formatClockStampDeviationDuration,
  type ClockStampDeviation,
  type ClockStampDeviationType,
} from "./clockStampTimeReportPanel.logic";

interface ClockStampDeviationNoticeProps {
  readonly deviations: readonly ClockStampDeviation[];
}

interface DeviationTranslationKeys {
  readonly labelKey: string;
  readonly valueKey: string;
}

const DEVIATION_TRANSLATIONS: Record<
  ClockStampDeviationType,
  DeviationTranslationKeys
> = {
  checkInEarly: {
    labelKey: "StampClock.CheckInDeviationLabel",
    valueKey: "StampClock.EarlyDeviation",
  },
  checkInLate: {
    labelKey: "StampClock.CheckInDeviationLabel",
    valueKey: "StampClock.LateDeviation",
  },
  checkOutEarly: {
    labelKey: "StampClock.CheckOutDeviationLabel",
    valueKey: "StampClock.EarlyDeviation",
  },
  checkOutLate: {
    labelKey: "StampClock.CheckOutDeviationLabel",
    valueKey: "StampClock.LateDeviation",
  },
};

export const ClockStampDeviationNotice = (
  props: ClockStampDeviationNoticeProps,
): JSX.Element => {
  const { t } = useTranslation();

  return (
    <DeviationSection role="status">
      <DeviationHeader>
        <CustomIcon
          aria-hidden="true"
          name="v2/warning-triangle"
          color={ColorV2.DarkAmbigiousYellow}
          size="22px"
        />
        <Text typography="b1" color={ColorV2.Blue1}>
          {t("StampClock.ScheduleDeviationTitle")}
        </Text>
      </DeviationHeader>
      <DeviationList>
        {props.deviations.map((deviation) => {
          const translation = DEVIATION_TRANSLATIONS[deviation.type];
          return (
            <DeviationRow key={deviation.type}>
              <Text typography="b2" color={ColorV2.Blue1}>
                {t(translation.labelKey)}
              </Text>
              <DeviationValue typography="b1">
                {t(translation.valueKey, {
                  duration: formatClockStampDeviationDuration(
                    deviation.minutes,
                  ),
                })}
              </DeviationValue>
            </DeviationRow>
          );
        })}
      </DeviationList>
      <Text typography="s1" color={ColorV2.Blue2}>
        {t("StampClock.ScheduleDeviationCommentPrompt")}
      </Text>
    </DeviationSection>
  );
};
